import React, { Component } from 'react';
import styled from 'styled-components';
import { Flex, media } from 'lib/style-utils';
import TopCircle from './TopCircle';
import { Link } from 'react-router-dom';

const Season = styled.div`
  text-align: center;
  font-size: 34px;
  font-weight: bold;
  letter-spacing: 6.1px;
  color: #333333;
  margin-top: -120px;

  ${media.mobile`
    margin-top: -50px;
    font-size: 28px;
  `};
`;

const Year = styled.div`
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1.6px;
  color: #888888;
  margin: 22px auto 82px;

  ${media.mobile`
    margin: 19px auto 42px;
    font-size: 14px;
  `};
`;

const CatalogContainer = styled.div`
  max-width: 1920px;
  width: 90%;
  margin: 0 auto;
`;

const CatalogWrapper = Flex.extend`
  width: 100%;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

const StyledLink = styled(Link)`
  display: inline-block;
  width: calc(20% - 20px);
  margin: 10px;

  ${media.w1200`
    width: calc(33.33% - 20px);
  `};

  ${media.mobile`
    width: calc(33.33% - 8px);
    margin: 4px;
  `};
`;

const Img = styled.img`
  width: 100%;
  transition: all 0.6s;
`;

const Btn = styled.button`
  display: inline-block;
  padding: 0px 30px;
  height: 45px;
  background: #ffffff;
  color: #999999;
  border: 1px solid #eeeeee;
  border-radius: 23px;
  text-align: center;
  font-size: 15px;
  letter-spacing: 1.2px;
  cursor: pointer;
  opacity: ${props => (props.toggleBacklist ? 1 : 0)};
  position: fixed;
  left: 72px;
  bottom: 50px;
  z-index: 20;
  transition: opacity 0.6s ease-in;

  &:hover {
    background: #f9f9f9;
  }

  &:active {
    background: #f2f2f2;
  }

  ${media.w1200`
    padding: 0px 20px;
    font-size: 14px;
    height: 40px;
    left: 40px;
  `};

  ${media.tablet`
    padding: 0px 32px;
    font-size: 15px;
  `};

  ${media.mobile`
    padding: 0px 20px;
    left: 20px;
  `};

  ${media.iphone67p`
    left: 10px;
  `};

  ${media.iphone67`
    left: 10px;
  `};
`;

class Catalog extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return this.props !== nextProps;
  }

  async componentDidMount() {
    const { DataActions, lookbookData } = this.props;
    const { onBacklist, offBacklist } = this.props.UIActions;

    window.scrollTo(0, 0);

    if (lookbookData === undefined || lookbookData.seasonText === '') {
      await DataActions.getLookbook();
    }

    if (this.props.lookbookData && this.props.lookbookData.images.length > 9) {
      onBacklist();
      window.addEventListener('scroll', this.handleScroll);
    } else {
      offBacklist();
    }
  }

  componentWillUnmount() {
    const { toggleBacklist } = this.props;
    const { offBacklist } = this.props.UIActions;

    if (toggleBacklist) {
      offBacklist();
    }

    if (this.props.lookbookData && this.props.lookbookData.images.length > 9) {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }

  handleGalleryOpen = e => {
    const { UIActions } = this.props;
    const index = e.target.getAttribute('data-index');
    UIActions.setGalleryIndex({ index });
  };

  handleScroll = e => {
    const toggleValue = window.innerWidth <= 600 ? 400 : 200;
    const { clientHeight } = document.body;
    const { innerHeight } = window;
    const scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    const { onBacklist, offBacklist } = this.props.UIActions;
    const { toggleBacklist } = this.props;

    const handleBackList = (e, isMobile) => {
      if (
        !toggleBacklist &&
        clientHeight - scrollTop - innerHeight >= toggleValue
      ) {
        onBacklist();
      } else if (
        toggleBacklist &&
        clientHeight - scrollTop - innerHeight < toggleValue
      ) {
        offBacklist();
      }
    };

    return handleBackList(e, toggleValue);
  };

  handleGoBack = () => {
    this.props.goBack();
  };

  render() {
    const { color, lookbookData, index, toggleBacklist } = this.props;
    const { handleGalleryOpen, handleGoBack } = this;

    return (
      <div>
        <TopCircle color={color} />
        <Season>{lookbookData && lookbookData.seasonText}</Season>
        <Year>{lookbookData && lookbookData.yearText}</Year>

        <CatalogContainer>
          <CatalogWrapper>
            {lookbookData &&
              lookbookData.images.map((image, i) => {
                return (
                  <CatalogImg
                    key={image._id}
                    image={image}
                    index={index}
                    dataIndex={i}
                    handleGalleryOpen={handleGalleryOpen}
                  />
                );
              })}
          </CatalogWrapper>
        </CatalogContainer>

        <Btn onClick={handleGoBack} toggleBacklist={toggleBacklist}>
          BACK TO LIST
        </Btn>
      </div>
    );
  }
}

class CatalogImg extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return this.props.dataIndex !== nextProps.dataIndex;
  }

  render() {
    const { image, index, dataIndex, handleGalleryOpen } = this.props;

    return (
      <StyledLink to={`/gallery/${index}`}>
        <Img
          src={image.url}
          data-index={dataIndex}
          onClick={handleGalleryOpen}
          alt=""
        />
      </StyledLink>
    );
  }
}

export default Catalog;



// WEBPACK FOOTER //
// ./src/components/Lookbook/Catalog.js